// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2354v","validationTips":"StatementDescriptor_validationTips__3wL1r"};